import { IGroup } from '@grassrootly/api/entities';
import withErrorCheck from "../CheckError";
import server from "../Server";
import { GenerateJoinCodePayload } from '@grassrootly/api/gateways';

const generateCode = (length: number): string => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

export const GenerateJoinCode = async (params: GenerateJoinCodePayload): Promise<IGroup> => {
  const group = withErrorCheck(await server.from("Groups").select().eq("id", params.id))[0];
  if (!group) {
    throw new Error("Group not found.");
  }
  
  // (group as any).join_code = generateCode(6);

  // return group;

  return withErrorCheck(
    await server
      .from("Groups")
      .update({ name: group.name, join_code: generateCode(6) })
      .eq("id", params.id)
      .select()
  )[0];
};